import {useSelector} from 'react-redux'

export const useSearch = () => useSelector((state) => state.header.search)

export const useMenuItems = () => useSelector((state) => state.header.menuItems)
